var layoutStyles = {"column":"side-panel__column_1hsbi","gap-16":"side-panel__gap-16_1hsbi","gap-24":"side-panel__gap-24_1hsbi","gap-32":"side-panel__gap-32_1hsbi","start":"side-panel__start_1hsbi","center":"side-panel__center_1hsbi","space-between":"side-panel__space-between_1hsbi"};
require('./components/footer/layout.css')

export { layoutStyles as l };
